import ErrorScreenTS from './ErrorScreenTS'

export default ErrorScreenTS
